import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { PaginatorModule } from 'primeng/paginator';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { QualityControlRejectApiService } from '../../api/reject.service';
import { Observable } from 'rxjs';
import { InspectionApiDto } from '../../../../api/elite/dto/inspection.dto';
import { AlertService } from '../../../../core/services/alert.service';

export type QualityControlRejectionTypes = {
  data: DataType;
  result: ResultType;
};

type DataType = {
  maxQuantity: number;
  workOrderId: number;
  inspectionStage: string;
  toStage?: string;
  shifts: { id: number; title: string }[];
  department: string;
};
type ResultType = {
  success: boolean;
  quantity: number;
};

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    PaginatorModule,
    ReactiveFormsModule,
  ],
  templateUrl: './register-rejection.component.html',
  styleUrls: ['./register-rejection.component.sass'],
})
export class QualityControlRegisterRejectionComponent implements OnInit {
  private readonly data: DataType = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef);
  private readonly service = inject(QualityControlRejectApiService);
  protected readonly alertService = inject(AlertService);

  form = new FormGroup({
    quantity: new FormControl<number>(undefined, [
      Validators.required,
      Validators.min(1),
    ]),
    shiftId: new FormControl<number>(undefined, [Validators.required]),
  });
  shifts = this.data.shifts || [];
  maxQuantity = this.data.maxQuantity;
  constructor() {}

  ngOnInit(): void {
    if (!this.data.shifts?.length) {
      this.service.all(this.data.department).subscribe((res) => {
        this.shifts = res;
      });
    }
  }

  onClickSave(): void {
    if (this.form.invalid) {
      return;
    }
    this.onReject().subscribe(
      () => {
        this.dialogRef.close({
          quantity: this.form.get('quantity').value,
          success: true,
        });
      },
      (err) => {
        this.alertService.error(`Error: ` + err);
      }
    );
  }

  onReject(): Observable<InspectionApiDto['reject']['result']> {
    return this.service.addRejectionRecord({
      quantity: this.form.get('quantity').value,
      fromStage: this.data.inspectionStage,
      toStage: this.data.toStage || 'Rejected from QC',
      workOrderId: this.data.workOrderId,
      shiftId: this.form.get('shiftId').value,
    });
  }
}
